import { useNavigate } from 'react-router-dom';
import { Package, Plus } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Button } from '@vnetwork/ui/primitives';
import { useItemModels } from '@/api/capacities';
import { MastersListSection } from '../shared/masters-list-section';
import { modelColumns } from './list-configs/model-column-definitions';

/**
 * Item Models master list — a `PageHeader` over the server-paginated
 * `MastersListSection` (search + model/name/type/category/status columns). Rows
 * link to the model detail route. Read-only (W1 scope).
 */
export default function CapacityModelsPage() {
  const navigate = useNavigate();

  return (
    <Container size="full">
      <PageHeader
        title="Models"
        description="Equipment and component models — the catalog of what the warehouse stocks."
        style={{ marginBottom: 'var(--vn-space-4)' }}
        actions={
          <Button startIcon={<Plus size={15} />} onClick={() => navigate('/capacities/models/new')}>
            New model
          </Button>
        }
      />

      <MastersListSection
        useList={useItemModels}
        columns={modelColumns}
        getRowId={(r) => r.id}
        onRowClick={(r) => navigate(`/capacities/models/${r.id}`)}
        searchPlaceholder="Search models…"
        emptyIcon={<Package size={24} />}
        emptyTitle="No models found"
        errorTitle="Failed to load models"
      />
    </Container>
  );
}
